import loadable from '@loadable/component';

export const OrgDashboardPreviewJobPageLoadable = loadable(
  () => import('./OrgDashboardPreviewJobPage'),
  { resolveComponent: (module) => module.OrgDashboardPreviewJobPage },
);
